import React, { useEffect, useState } from 'react';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';

import {
  userKycRentUpload,
  UploadFileToS3,
  userKycRentalAggrementUploaded
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import { GetImgComp } from '../../../containers/UserKyc/UserKycComponent/UserVoterCard/GetImgComp';

const RentalAgreement = props => {
  const {
    values,
    data,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched
  } = props;
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('loading...');
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);

  const feddBackofUploadedFile = data => {
    userKycRentalAggrementUploaded(leadId, applicantId, data.requestId)
      .then(res => {
        if (res.error) {
          throw new Error(res.error.data.message);
        }
        setShow(false);
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };

  const uploadFileToS3 = (data, file) => {
    if (data.url && data.requestId) {
      UploadFileToS3(data.url, file)
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          feddBackofUploadedFile(data);
        })
        .catch(async err => {
          await setPopUpType('fail');
          await setPopUpText(err.toString());
          setShow(true);
        });
    }
  };

  useEffect(() => {
    const handleUpload = async () => {
      let file = values.file[values.UploadRent][0];

      await setPopUpType('loading');
      await setPopUpText('Uploading File...');
      setShow(true);

      userKycRentUpload(leadId, applicantId)
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          uploadFileToS3(res, file);
        })
        .catch(async err => {
          await setPopUpType('fail');
          await setPopUpText(err.toString());
          setShow(true);
        });
    };
    if (values.file[values.UploadRent]) {
      handleUpload();
    }
  }, [values.file[values.UploadRent]]);
  return (
    <div className="bg-white border border-purple-300  md:border-0 w-full px-2 rounded-lg">
      <div className=" w-full flex lg:px-5  md:mx-auto ">
        <div className=" md:block md:w-10/12 lg:w-9/12 xl:w-6/12  md:mr-5 px-3">
          <p className="text-base font-roboto font-normal text-black-600 text-sm pt-5 mb:pt-0 pb-5">
            Upload Rental agreement
          </p>
          {/* {values.showPreviousImage.toString()} */}
          {values.showPreviousImage && !edit ? (
            <GetImgComp imgUrl={values.showPreviousImage} setEdit={setEdit} />
          ) : (
            <GlobalUploadComp
              data={values}
              imgIndex={values.UploadRent} //0,1,2,3 depending upon the no of file sequence
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              subInst="Upload Front Page of Rental Aagreement"
              subtext="Click Here"
            />
          )}
          <div className="w-full flex my-8 md:mx-auto flex items-center">
            <div className="w-full ">
              <InputTypeNumber
                name="monthlyRent"
                maxLength={7}
                minLength={0}
                legendName={'Rent per Month'}
                value={values.monthlyRent}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={false}
                error={touched.monthlyRent && errors.monthlyRent}
                errorMsg={errors.monthlyRent}
                touched={touched.monthlyRent}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
              />
            </div>
          </div>
        </div>
      </div>
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};

export default RentalAgreement;
